import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AssignTelecallerService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    private baseUrl = 'api/assignTelecaller';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    getAllAssignedToList(): Promise<any> {
        let options = new RequestOptions({ headers: this.headers });
        return this.http.get(`${this.baseUrl}/getAllAssignedToList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    getTelecallerList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getTelecallerList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    getFollowupStatusList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getFollowupStatusList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    getRecordList(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) { params.set(key.toString(), query[key]); }
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.baseUrl}/getRecordList`, options)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    assignSelected(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/assignSelected`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }

    autoDistributePreview(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/autoDistributePreview`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }

    autoDistribute(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/autoDistribute`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }

    redistributeAllPreview(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/redistributeAllPreview`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }

    redistributeAll(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/redistributeAll`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json() as any).catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/assignTelecaller.service.ts